<template>
  <v-container fluid pa-0>
    <v-row align="center" justify="center" style="height: 60vh">
      <v-col class="flex-column align-center">

        <!--front card login -->
        <v-card class="mx-auto text-center p-10 " max-width="400" min-height="300" elevation="10" :loading="loading">
          <template slot="progress">
            <v-progress-linear color="red" indeterminate></v-progress-linear>
          </template>

          <v-app-bar dark color="#37424A">
            <v-toolbar-title>Acceso a cursos</v-toolbar-title>
          </v-app-bar>

          <v-form ref="form" v-model="invalid" class="pl-4 pr-4" @submit.prevent="handleLogin">
            <br />
            <div class="red--text">{{ msg }}</div>
            <v-row>
              <v-col>
                <v-text-field v-model="user.email" label="Email" :rules="emailRules" single-line></v-text-field>
                <v-text-field v-model="user.password" :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                  :rules="[passRules.required, passRules.min]" label="Contraseña" :type="show ? 'text' : 'password'"
                  counter @click:append="show = !show" single-line></v-text-field>
              </v-col>
            </v-row>

            <v-card-actions class="justify-center">
              <v-btn depressed color="error" class="text-capitalize " type="submit" :disabled="!invalid">
                Iniciar Sesión
              </v-btn>
            </v-card-actions>

          </v-form>
        </v-card>

      </v-col>
    </v-row>
  </v-container>
</template>


<script>
import User from '@/models/user';
import crypto from "crypto-js";

export default {
  name: 'LoginComponet',

  data() {
    return {
      invalid: false,
      loading: false,
      show: false,
      user: new User('', '', ''),
      msg: '',
      password: "",
      passRules: {
        required: (value) => !!value || "requerido.",
        min: (v) => v.length >= 8 || "Min 8 characteres",
      },
      email: "",
      emailRules: [
        (v) => !!v || "E-mail es requerido",
        (v) => /.+@.+\..+/.test(v) || "E-mail no es valido",
      ],
    };
  },
  mounted(){
    if(sessionStorage.user){
      this.$router.replace({ name: "catalogo" });

    }
  },

  methods: {
    handleLogin() {
      
      this.user.email.trim();
      this.user.password.trim();

      this.loading = true;
      if (this.user.email.length > 0 && this.user.password.length > 0) {
        var strvalidate = crypto.SHA256(this.user.email + '#_UAndes_#_Profesor');
        //var strvalidate = crypto.SHA256(this.user.email + '#_UAndes_Profesores#');
         // console.log('hash generado : '+strvalidate.toString().substring(0,8));

        if (strvalidate.toString().substring(0, 8) == this.user.password) {
          console.log(strvalidate);
          this.savelstorage();
          this.$router.replace("catalogo")

        } else {
          this.msg = 'Nombre de usuario o contraseña no validos'
          this.loading = false;
        }
      }
    },
    savelstorage() {
      sessionStorage.user = {
        'user': this.user.email,
        'time': new Date()
      }

    }
  },

}
</script>
<style>
body{
  background-color: #ffffff;
}
</style>